import { render, staticRenderFns } from "./u-card-elevated-rounded.vue?vue&type=template&id=ba55f542&scoped=true&"
import script from "./u-card-elevated-rounded.vue?vue&type=script&lang=js&"
export * from "./u-card-elevated-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba55f542",
  null
  
)

export default component.exports